import React from 'react';
import { useTranslation } from 'react-i18next';
import { InfoMessageTypeEnum } from '@websky/graphql';

import { useConfig } from '../../../context';
import { useTheme } from '../../../theme';
import Notification from '../../../Notification';
import Link from '../../../Link';

export const MobileBaggageRules = () => {
	const classes = useTheme('BaggagePage').MobileBaggageRules;
	const { t } = useTranslation();
	const { companyInfo } = useConfig().global;

	return (
		<Link className={classes.wrapper} target="_blank" action={companyInfo.baggage}>
			<Notification
				className={classes.notification}
				textClassName={classes.notificationText}
				iconClassName={classes.notificationIcon}
				type="context"
				status={InfoMessageTypeEnum.Info}
				infoMessage={{
					text: t('Checkout:Baggage rules'),
					code: 'baggage-rules',
					type: InfoMessageTypeEnum.Info
				}}
			/>
		</Link>
	);
};
